/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root? for license information.
 */
// import * as React from 'react';
// import { ICustomLinkViewProps } from './custom-link';
// import { HrefCustomLink } from './components/link';

// const CustomLinkView: React.FC<ICustomLinkViewProps> = props => {
//     const { root } = props.config;
//     return (<HrefCustomLink text={root?.linkText} ariaLabel={root?.ariaLabel || root?.linkText} href={root?.linkUrl.destinationUrl} />);
// };
// export default CustomLinkView;

import * as React from 'react';
import { ICustomLinkViewProps } from './custom-link';
import { HrefCustomLink } from './components/link';

const CustomLinkView: React.FC<ICustomLinkViewProps> = props => {
    const { root } = props.config;
    return <HrefCustomLink text={root?.linkText} ariaLabel={root?.ariaLabel || root?.linkText} href={root?.linkUrl.destinationUrl} />;
};
export default CustomLinkView;
